/*!
 *
 * page2top.js
 *
 */

var $page2top = $('#Page2Top');
var $conv = $('#Conv');

var getLimit = function(){
	return $conv.offset().top - origin.wh;
};

module.exports = function(){

	var limit = getLimit();
	var isAbs = false;

	$(window).on('scroll', function(){
		var _top = $(this).scrollTop();
		if( !isAbs && _top > limit ){
			isAbs = true;
			$page2top.addClass('st-Page2Top-stop');
		};
		if( isAbs && _top <= limit ){
			isAbs = false;
			$page2top.removeClass('st-Page2Top-stop');
		}
	});

	$(window).on('load', function(){
		limit = getLimit();
	});

	$(window).on('resize', function(){
		limit = getLimit();
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/page2top.js
// module id = 23
// module chunks = 0 1